// Thank's IE8 for his funny defineProperty
module.exports = !require('./_fails')(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});



//////////////////
// WEBPACK FOOTER
// C:/Front-end/[PROYECTO] abordo-empresarial-cli4/[RAMA] actualizarAngular-Analytics/abordo-empresarial-cli4/~/core-js/modules/_descriptors.js
// module id = ../../../../core-js/modules/_descriptors.js
// module chunks = 0